import(/* webpackMode: "eager" */ "/vercel/path0/app/scripts/templateinstaller/page.tsx");
